import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    clients:[],
    search_clients:[],
    total: 0,
    balance: 0,
  }),
  mutations: {
    SET_CLIENTS(state, items) {
      state.clients = items
    },
    SET_SEARCH_CLIENTS(state, items) {
      state.search_clients = items
    },
    SET_TOTAL(state, items) {
      state.total = items
    },
    SET_BALANCE(state, items) {
      state.balance = items
    }
  },
  actions: {
    async fetchClients({ commit }, data) {
      const res = await apiClient('clients.get', data)
      commit('SET_CLIENTS', res.list)
      commit('SET_TOTAL', res.total)
    },
    async searchClients({ commit }, data) {
      const res = await apiClient('clients.search', data)
      commit('SET_SEARCH_CLIENTS', res.list)
    },
    async saveClient(_, scheduleData) {
      return await apiClient('clients.create', scheduleData)
    },
    async saveQuickClient({ commit }, scheduleData) {
      const res = await apiClient('clients.create_quick', scheduleData)
      commit('SET_CLIENTS', res.list)
      commit('SET_TOTAL', res.total)
      return res
    },
    async updateClient({ commit }, scheduleData) {
      const res = await apiClient('clients.update', scheduleData)
      commit('SET_CLIENTS', res.list)
      commit('SET_TOTAL', res.total)
    },
    async deleteClient({ commit }, id) {
      const res = await apiClient('clients.delete', { id })
      commit('SET_CLIENTS', res.list)
      commit('SET_TOTAL', res.total)
    },
    async getBalance({ commit }, id) {
      const res = await apiClient('clients.balance', { id })
      commit('SET_BALANCE', res.balance)
    },
    async getClientById(_, data) {
      return  await apiClient('clients.getOne', data)
    }
  }
}
